import { HOW_IT_WORKS } from '../../config/site';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-white scroll-mt-[132px]">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary text-center mb-12 md:mb-16">
          HOW IT WORKS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {HOW_IT_WORKS.map((step) => (
            <div key={step.number} className="text-center">
              <p className="font-display text-5xl text-sage-dark mb-4">{step.number}</p>
              <h3 className="font-inter text-xs font-medium tracking-[0.2em] uppercase text-text-primary mb-3">
                {step.title}
              </h3>
              <p className="font-inter text-sm leading-relaxed text-text-muted max-w-xs mx-auto">
                {step.detail}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
